import store from '../../../admin/store'
import { SET_IMAGE_CROPPER } from '../../../admin/reducers/image-cropper'
import getCroppedImg from './crop-image'

/**
 * On crop result
 *
 * @param {Object} croppedArea
 * @param {Object} croppedAreaPixels
 */
export const onCropComplete = (croppedArea, croppedAreaPixels) => {
    store.dispatch({
        type: SET_IMAGE_CROPPER,
        data: {
            croppedAreaPixels: croppedAreaPixels,
        },
    })
}

/**
 * On crop changing
 *
 * @param {Object} crop
 */
export const onCropChange = crop => {
    store.dispatch({
        type: SET_IMAGE_CROPPER,
        data: {
            crop: crop,
        },
    })
}

/**
 * On zoom changing
 *
 * @param {string} zoom
 */
export const onZoomChange = zoom => {
    store.dispatch({
        type: SET_IMAGE_CROPPER,
        data: {
            zoom: zoom,
        },
    })
}

/**
 * Get cropped image result
 *
 * @return {Promise<string>}
 */
export const getResult = () => {
    try {
        store.dispatch({
            type: SET_IMAGE_CROPPER,
            data: {
                isCropping: true,
            },
        })

        const {
            imageSrc,
            croppedAreaPixels,
        } = store.getState().imageCropper

        return getCroppedImg(imageSrc, croppedAreaPixels)
            .then(croppedImage => {
                store.dispatch({
                    type: SET_IMAGE_CROPPER,
                    data: {
                        croppedImage: croppedImage,
                        isCropping: false,
                    },
                })

                return new Promise(resolve => resolve(croppedImage))
            })
    } catch (e) {
        store.dispatch({
            type: SET_IMAGE_CROPPER,
            data: {
                isCropping: false,
            },
        })
    }

    return new Promise(resolve => resolve())
}
